import { Link } from "react-router-dom";
import { ShieldCheck, FileText, UserPlus, ShieldAlert, Globe, BarChart3, Stethoscope, Activity, Tablet, PlayCircle } from "lucide-react";

const TABS = [
  { id: "verify",        to: "/admin/verify",        label: "Verification queue", icon: ShieldCheck },
  { id: "audit-log",     to: "/admin/audit-log",     label: "Audit log",          icon: FileText },
  { id: "grant",         to: "/admin/grant",         label: "Grant role",         icon: UserPlus },
  { id: "security",      to: "/admin/security",      label: "Security",           icon: ShieldAlert },
  { id: "region",        to: "/admin/region",        label: "Region & waitlist",  icon: Globe },
  { id: "funnel",        to: "/admin/funnel",        label: "Funnel",             icon: BarChart3 },
  { id: "doctor-codes",  to: "/admin/doctor-codes",  label: "Doctor codes",       icon: Stethoscope },
  { id: "child-devices", to: "/admin/child-devices", label: "Child devices",      icon: Tablet },
  { id: "media",         to: "/admin/media",         label: "Landing media",      icon: PlayCircle },
  { id: "pilot",         to: "/admin/pilot",         label: "Pilot review",       icon: Activity },
];

export default function AdminTabs({ current }) {
  return (
    <nav className="flex flex-wrap gap-2 mb-6" data-testid="admin-tabs">
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = current === t.id;
        return (
          <Link
            key={t.id}
            to={t.to}
            className={`pill-btn ${active ? "gold" : ""}`}
            aria-current={active ? "page" : undefined}
            data-testid={`admin-tab-${t.id}`}
          >
            <Icon size={14} /> {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
